import { useEffect, useState } from 'react';
import { Package } from '../../../models';

const useBackgroundsFromPackage = (packageId) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!packageId) return;

    Package
      .includes([{ backgroundSet: ['backgrounds'] }])
      .find(packageId)
      .then((res) => {
        if (!res.data.backgroundSet) {
          setData([]);
          return;
        }

        setData(res.data.backgroundSet.backgrounds);
      });
  }, [packageId]);

  return data;
};

export default useBackgroundsFromPackage;
